// 销售展厅指标统计
export default {
  field_from_api: {
    arrived: {
      name: '到店量(客流)'
    },
    review: {
      name: '草签数'
    },
    deal: {
      name: '成交数'
    }
  },
  getData: function (params = {}) {
    this.$rest.dataAnalysis.getStatistical(params).then(res => {
      if (res.code === 0) {
        this.dataList = res.data
      } else {
        this.showToast(res.message)
      }
    })
  }
}
